"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importStar(require("react"));
var socket_io_client_1 = __importDefault(require("socket.io-client"));
require("../../assets/styles/chat.css");
var Message_1 = __importDefault(require("./Message"));
var Button_1 = __importDefault(require("@mui/material/Button"));
var Send_1 = __importDefault(require("@mui/icons-material/Send"));
var react_toastify_1 = require("react-toastify");
require("react-toastify/dist/ReactToastify.css");
var CircularProgress_1 = __importDefault(require("@mui/material/CircularProgress"));
var Box_1 = __importDefault(require("@mui/material/Box"));
var IconButton_1 = __importDefault(require("@mui/material/IconButton"));
var ArrowCircleDown_1 = __importDefault(require("@mui/icons-material/ArrowCircleDown"));
var js_cookie_1 = __importDefault(require("js-cookie"));
var material_1 = require("@mui/material");
function scrollToBottom(ref) {
    if (ref.current) {
        ref.current.scrollTop = ref.current.scrollHeight;
    }
}
function getCookie(name) {
    // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment, @typescript-eslint/no-unsafe-member-access, @typescript-eslint/no-unsafe-call
    var gettoken = js_cookie_1.default.get(name);
    return gettoken;
}
var token = getCookie("token");
var socket = token
    ? (0, socket_io_client_1.default)(process.env.BACKEND_LINK, { query: { token: token } })
    : undefined;
var Chatscreen = function () {
    var _a = (0, react_1.useState)([]), messages = _a[0], setMessages = _a[1];
    var _b = (0, react_1.useState)(""), inputValue = _b[0], setInputValue = _b[1];
    var _c = (0, react_1.useState)(""), errorMessage = _c[0], setErrorMessage = _c[1];
    var _d = (0, react_1.useState)(true), loading = _d[0], setLoading = _d[1];
    var _e = (0, react_1.useState)({
        id: null,
        role: "",
        name: "",
        phone: null,
        email: "",
    }), userData = _e[0], setUserData = _e[1];
    var MessageDiv = (0, react_1.useRef)(null);
    var handleScroll = function () {
        scrollToBottom(MessageDiv);
    };
    (0, react_1.useEffect)(function () {
        if (socket == undefined) {
            return;
        }
        socket.on("new-user", function (user) {
            setUserData(user);
            socket === null || socket === void 0 ? void 0 : socket.emit("connected", user.name);
            (0, react_toastify_1.toast)("welcome ".concat(user.name, " "), {
                type: "info",
            });
        });
        socket === null || socket === void 0 ? void 0 : socket.on("failure_connection", function (message) {
            (0, react_toastify_1.toast)("".concat(message.error), {
                type: "error",
            });
        });
        socket === null || socket === void 0 ? void 0 : socket.on("chat-message", function (data) {
            displayMessage(data.person, data.message);
        });
        socket === null || socket === void 0 ? void 0 : socket.on("recents", function (chats) {
            var allmessages = [];
            chats.forEach(function (chat) {
                allmessages.push({ sender: chat[0].sender, message: chat[0].message });
            });
            setMessages(allmessages);
            setLoading(false);
            scrollToBottom(MessageDiv);
        });
        socket === null || socket === void 0 ? void 0 : socket.on("bye", function (data) {
            (0, react_toastify_1.toast)("".concat(data.person, " : ").concat(data.message, " "), {
                type: "info",
            });
        });
    }, []);
    if (token == undefined) {
        (0, react_toastify_1.toast)("Please login first", {
            type: "error",
        });
        return (react_1.default.createElement("div", null,
            react_1.default.createElement(react_toastify_1.ToastContainer, { theme: "light" })));
    }
    var sendMessage = function (e) {
        e.preventDefault();
        if (!inputValue.trim()) {
            (0, react_toastify_1.toast)("Please provide a message", {
                type: "error",
            });
            return;
        }
        if (!socket) {
            (0, react_toastify_1.toast)("Please login", {
                type: "error",
            });
            return;
        }
        if (userData.id) {
            socket.emit("chat", {
                senderId: userData.id,
                person: userData.name,
                message: inputValue,
            });
        }
        else {
            (0, react_toastify_1.toast)("Loading please wait", {
                type: "error",
            });
        }
        displayMessage(userData.name, inputValue);
        setInputValue("");
        setErrorMessage("");
    };
    var displayMessage = function (person, message) {
        setMessages(function (prevMessages) { return __spreadArray(__spreadArray([], prevMessages, true), [
            { sender: person, message: message },
        ], false); });
    };
    return (react_1.default.createElement("div", null,
        react_1.default.createElement(react_toastify_1.ToastContainer, { theme: "light" }),
        react_1.default.createElement("div", { className: "container" },
            react_1.default.createElement(IconButton_1.default, { size: "large", color: "primary", onClick: handleScroll },
                react_1.default.createElement(ArrowCircleDown_1.default, null)),
            react_1.default.createElement("div", { className: "title" },
                react_1.default.createElement("h2", null, "Chats")),
            react_1.default.createElement("div", { className: "messages", ref: MessageDiv },
                loading ? (react_1.default.createElement(Box_1.default, { sx: {
                        width: "100%",
                        height: "100%",
                        left: "unset",
                        display: "flex",
                        alignItems: "center",
                    } },
                    react_1.default.createElement(Box_1.default, { sx: { width: "100%", display: "flex", alignItems: "center" } },
                        react_1.default.createElement(CircularProgress_1.default, { color: "primary", sx: { zIndex: "100", margin: "auto" } })))) : (react_1.default.createElement(react_1.default.Fragment, null)),
                messages.map(function (_a, index) {
                    var sender = _a.sender, message = _a.message;
                    return (react_1.default.createElement("div", { className: "message ".concat(sender === userData.name ? "mine" : ""), key: index },
                        react_1.default.createElement(Message_1.default, { sender: sender, message: message })));
                })),
            react_1.default.createElement("div", { className: "formBox" },
                react_1.default.createElement("form", { onSubmit: sendMessage },
                    react_1.default.createElement("input", { type: "text", value: inputValue, onChange: function (e) { return setInputValue(e.target.value); }, required: true, name: "txt", placeholder: "Type a message", autoComplete: "off" }),
                    react_1.default.createElement(Button_1.default, { size: "small", color: "primary", variant: "contained", type: "submit", endIcon: react_1.default.createElement(Send_1.default, null) },
                        react_1.default.createElement(material_1.Typography, { sx: { display: { xs: "none", sm: "block" } } },
                            " ",
                            "Send"))),
                errorMessage && react_1.default.createElement("span", { className: "error" }, errorMessage)))));
};
exports.default = Chatscreen;
